import { FC } from 'react';

import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

import {
  TOOTH_ATTACHMENT,
  TOOTH_ATTACHMENT_OPTIONS
} from 'constants/prescriptionOptions';
import { translate } from 'utils';

import { FormLabel } from './FormLabel/FormLabel';
import RhfRadioGroup from './RadioGroup/RhfRadioGroup/RhfRadioGroup';
import { RHFTextArea } from './RHFTextArea/RHFTextArea';
import RhfToothChart from './ToothChart/RhfToothChart';
interface Props {
  fieldName: string;
  title: string;
  animateLabel: string;
  isDisabled?: boolean;
  isUpperDisabled?: boolean;
  isLowerDisabled?: boolean;
  isToothChartRestricted?: boolean;
}
const ToothAttachment: FC<Props> = ({
  fieldName,
  title,
  isDisabled,
  animateLabel,
  isUpperDisabled,
  isLowerDisabled,
  isToothChartRestricted
}) => {
  const {
    watch,
    formState: { errors }
  } = useFormContext();
  const watchAttachmentSelection = watch(`${fieldName}.attachment`);
  const restrictedToothChartValue = watch(
    fieldName.replace(/\.toothAttachment$/, '.toothInformation') + '.toothChart'
  );
  const fieldError = _.get(errors, `${fieldName}`);
  return (
    <div className='flex flex-col'>
      <FormLabel
        label={translate(title)}
        className='md:text-17px mb-4'
        error={!!fieldError}
        name={animateLabel}
      />
      <div>
        <RhfRadioGroup
          inputProps={{ disabled: isDisabled }}
          options={TOOTH_ATTACHMENT_OPTIONS}
          name={`${fieldName}.attachment`}
          className='flex flex-row space-x-16'
          radioClassName='border-RADIO_BORDER'
          radioItemFont='md:text-17px text-sm '
        />
      </div>

      {watchAttachmentSelection === TOOTH_ATTACHMENT.NO_ATTACHMENT && (
        <div className='my-6 ml-5'>
          <RhfToothChart
            isBaby={false}
            showError={false}
            name={`${fieldName}.toothChart`}
            disabled={isDisabled}
            isUpperDisabled={isUpperDisabled}
            isLowerDisabled={isLowerDisabled}
            isToothChartRestricted={isToothChartRestricted}
            restrictedToothChartValue={restrictedToothChartValue}
          />
        </div>
      )}
      <div className='bg-GRAY5 flex flex-col p-4 rounded-2xl mt-4'>
        <p className='mb-3 text-14px'>
          {translate('tooth_attachment_restriction.instruction')}
        </p>
        <RHFTextArea
          name={`${fieldName}.primaryDentition`}
          autogrow
          inputProps={{
            disabled: isDisabled,
            placeholder: translate('settings.please_type_here')
          }}
          maxgrowHeight={260}
        />
      </div>
    </div>
  );
};
export default ToothAttachment;
